import React from 'react';
import cx from 'classnames';

import getPRColor from './getPRColor';

import { CLASSPROGRESS_COLORS } from "./constants";
import ARMFloor, { withScoreLessThanDecorator } from '../../blocks/ARMFloor';

export default function ClassProgressCell(props) {
  const {season, isBenchmarkOnly, benchmarkGrade, benchmarkName, studentName, selectedLocale} = props;
  const {score, cutOff, latestScore, scaleId} = season;

  const isValidScore = score || (['ARM','Lexile'].includes(scaleId) && score == 0);

  // get the WCPM color of cell based on cutOff
  const wcpmColor = cutOff && isValidScore ? {POOR: CLASSPROGRESS_COLORS.RED, AVERAGE: CLASSPROGRESS_COLORS.YELLOW, GOOD: CLASSPROGRESS_COLORS.GREEN}[cutOff] : null;
  const wcpmBgColor = wcpmColor ? `classProgress${wcpmColor}Bg` : "classProgressDefaultBg";
  const cellWCPMStyle = cx({
    "classProgressCellData": true,
    [wcpmBgColor]: true,
  });

  const PR = season.PR;
  const cellPRStyle = cx({
    "classProgressCellData": true,
    [wcpmBgColor]: true, // We want the PR background color to be determined based on the score cutlines, so set the the same as the score cell's color. We were previously using getPRColor(PR)
  });

  return (
    <div className="classProgressCell">
      <ARMFloor percentile={PR} metric={scaleId} grade={benchmarkGrade} benchmarkName={benchmarkName} firstName={studentName} locale={selectedLocale}/>
      <div className={cellWCPMStyle}>{withScoreLessThanDecorator({percentile: PR, metric: scaleId, grade: benchmarkGrade, displayedString: score, locale: selectedLocale}) ?? " "}</div>
      <div className={cellPRStyle}>{PR ?? " "}</div>
      {!isBenchmarkOnly && <div className="classProgressCellData classProgressDefaultBg">{latestScore ?? " "}</div>}
    </div>
  );
}
